import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowLeft, User } from "lucide-react";
import { Navbar } from "@/components/Navbar";
import { Footer } from "@/components/Footer";
import { api } from "@/lib/api";
import { formatDateID } from "@/lib/format";

export default function NewsDetail() {
  const { id } = useParams();
  const [news, setNews] = useState(null);
  const [notFound, setNotFound] = useState(false);

  useEffect(() => {
    window.scrollTo(0, 0);
    api.get(`/news/${id}`).then((r) => setNews(r.data)).catch(() => setNotFound(true));
  }, [id]);

  return (
    <div className="min-h-screen bg-[#090A0F]">
      <Navbar />
      <main className="mx-auto max-w-3xl px-4 pb-24 pt-32 sm:px-6">
        <Link to="/berita" data-testid="news-detail-back-link" className="mb-8 inline-flex items-center gap-2 text-sm font-semibold text-rose-400 hover:text-rose-300">
          <ArrowLeft className="h-4 w-4" /> Kembali ke Berita
        </Link>
        {notFound && (
          <p data-testid="news-not-found" className="rounded-xl border border-white/10 bg-[#12141C]/90 p-10 text-center text-slate-400">
            Berita tidak ditemukan.
          </p>
        )}
        {!news && !notFound && <p className="text-slate-500">Memuat...</p>}
        {news && (
          <motion.article initial={{ opacity: 0, y: 16 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.4 }} className="space-y-6">
            <span className="inline-block rounded-md border border-rose-500/30 bg-rose-500/10 px-2.5 py-1 font-mono text-xs uppercase tracking-widest text-rose-400">
              {news.category}
            </span>
            <h1 data-testid="news-detail-title" className="font-heading text-4xl font-extrabold uppercase leading-tight text-white sm:text-5xl">
              {news.title}
            </h1>
            <div className="flex flex-wrap items-center gap-4 font-mono text-xs uppercase tracking-widest text-slate-500">
              <span className="flex items-center gap-1.5"><User className="h-3.5 w-3.5" />{news.author || "Pengurus 3C Jatim"}</span>
              <span>{formatDateID(news.created_at)}</span>
            </div>
            {news.image_url && (
              <img src={news.image_url} alt={news.title} className="w-full rounded-xl border border-white/10 object-cover shadow-2xl shadow-black/60" />
            )}
            <div data-testid="news-detail-content" className="space-y-5 text-base leading-relaxed text-slate-300 md:text-lg">
              {news.content.split(/\n+/).filter(Boolean).map((p, i) => <p key={i}>{p}</p>)}
            </div>
          </motion.article>
        )}
      </main>
      <Footer />
    </div>
  );
}
